module.exports = __webpack_public_path__ + "static/media/gallery-new-1.197dc86b.jpg";